import React, { useState } from 'react';

import DeviceBackupContainer, {
  containerConfiguration,
} from '@totem/components/services/backup/deviceBackups/deviceBackupContainer';
import DeviceBackupTable from '@totem/components/services/backup/deviceBackups/deviceBackupTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { Filter } from '@totem/types/common';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  pRegionId: string[];
  pBuildingId: string[];
  pControlSystemId: string[];
  pDeviceId: string[];
  componentKey?: string;
};

const DeviceBackupPanel = ({
  pRegionId,
  pBuildingId,
  pControlSystemId,
  pDeviceId,
  componentKey,
}: Props) => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const staticFilters: Filter[] = [];
  if (isNotNull(pRegionId) && pRegionId.length > 0) {
    staticFilters.push({ field: 'regionId', values: pRegionId });
  }
  if (isNotNull(pBuildingId) && pBuildingId.length > 0) {
    staticFilters.push({ field: 'buildingId', values: pBuildingId });
  }
  if (isNotNull(pControlSystemId) && pControlSystemId.length > 0) {
    staticFilters.push({ field: 'controlSystemId', values: pControlSystemId });
  }
  if (isNotNull(pDeviceId) && pDeviceId.length > 0) {
    staticFilters.push({ field: 'deviceId', values: pDeviceId });
  }

  return (
    <InputContainer
      filterConfig={containerConfiguration}
      staticFilters={staticFilters.length > 0 ? staticFilters : undefined}
      defaultSort={{ field: 'device.displayName', direction: 'ascend' }}
      componentKey={componentKey}
    >
      <DeviceBackupContainer
        onTotalRecordsChanged={(count: number) => setTotalRecords(count)}
      >
        <IBCard
          isCovered
          title="Device Backups"
          extra={<RecordCountBadge count={totalRecords} />}
        >
          <DeviceBackupTable />
        </IBCard>
      </DeviceBackupContainer>
    </InputContainer>
  );
};

export default DeviceBackupPanel;
